import { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import api from "@/lib/api";

function SponsorTile({ s }) {
  const [imgOk, setImgOk] = useState(true);
  return (
    <a
      data-testid={`sponsor-${s.id}`}
      href={s.website || "#"}
      target="_blank"
      rel="noreferrer"
      className="group border border-jpa-border bg-white flex flex-col items-center justify-center hover:border-jpa-primary transition-colors overflow-hidden"
    >
      <div className="w-full aspect-[16/10] grid place-items-center p-6 bg-jpa-surface/40">
        {s.logo_url && imgOk ? (
          <img
            src={s.logo_url}
            alt={s.name}
            onError={() => setImgOk(false)}
            className="max-h-20 max-w-full object-contain grayscale group-hover:grayscale-0 transition-all"
          />
        ) : (
          <span className="font-display text-3xl md:text-4xl tracking-wider text-jpa-primary text-center break-words px-2">{s.name}</span>
        )}
      </div>
      <div className="w-full border-t border-jpa-border py-3 px-4 flex items-center justify-between">
        <span className="font-bold uppercase text-sm text-jpa-ink truncate">{s.name}</span>
        <span className="text-[10px] font-bold uppercase tracking-widest text-jpa-primary">{s.tier}</span>
      </div>
    </a>
  );
}

function Section({ title, tier, sponsors }) {
  const list = sponsors.filter((s) => s.tier === tier);
  if (list.length === 0) return null;
  return (
    <div className="mb-16">
      <div className="flex items-center gap-4 mb-6">
        <h2 className="font-display text-4xl tracking-wider text-jpa-ink">{title}</h2>
        <div className="h-px flex-1 bg-jpa-border" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {list.map((s) => <SponsorTile key={s.id} s={s} />)}
      </div>
    </div>
  );
}

export default function SponsorsPage() {
  const [sponsors, setSponsors] = useState([]);
  useEffect(() => { api.get("/sponsors").then((r) => setSponsors(r.data)); }, []);
  return (
    <div data-testid="sponsors-page">
      <PageHero eyebrow="Powered by" title="SPONSORS" subtitle="The brands and partners powering pickleball in Jharkhand."
        image="https://images.pexels.com/photos/7005050/pexels-photo-7005050.jpeg?w=1800" />
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14">
        <Section title="Prime Sponsors" tier="prime" sponsors={sponsors} />
        <Section title="Partners" tier="partner" sponsors={sponsors} />
        <Section title="Suppliers" tier="supplier" sponsors={sponsors} />
      </div>
    </div>
  );
}
